import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

Vue.prototype.$host = "https://credovita-flapp.azurewebsites.net/api";
Vue.prototype.$domain = "https://credovita-flapp.azurewebsites.net";

Vue.config.productionTip = false;

import Buefy from 'buefy'
Vue.use(Buefy);

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);

import VueMaterial from 'vue-material'
Vue.use(VueMaterial);

import VueMeta from 'vue-meta'
Vue.use(VueMeta);

import FBSignInButton from 'vue-facebook-signin-button'
Vue.use(FBSignInButton);

import VueVisual from 'vue-visual'
Vue.component('visual', VueVisual);

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
    config: { id: "UA-142751471-3" },
    bootstrap: false
});

Vue.filter("number", function (value) {
    return new Intl.NumberFormat('en-US').format(value)
});

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app');
